import React from 'react';

const NextWednesdayDate = () => {
  // Function to get the next Wednesday date
  const getNextWednesday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 is Sunday, 1 is Monday, ..., 3 is Wednesday
    
    // Calculate days until next Wednesday (3)
    // If today is Wednesday (3), we want next Wednesday (+7)
    // If today is after Wednesday (4, 5, 6), we want days until next Wednesday
    // If today is before Wednesday (0, 1, 2), we want days until this Wednesday
    const daysUntilWednesday = dayOfWeek === 3 ? 7 : (3 + 7 - dayOfWeek) % 7;
    
    // Create a new date by adding the days until Wednesday
    const nextWednesday = new Date(today);
    nextWednesday.setDate(today.getDate() + daysUntilWednesday);
    
    // Format the date in German style (DD.MM.YYYY)
    return nextWednesday.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="mt-6 mb-10 text-center">
      <p className="text-xl font-semibold">Nächste kostenlose Probestunde:</p>
      <p className="text-2xl mt-2 font-bold text-custom_tertiary  border-3 border-custom_tertiary rounded-xl">
        Mittwoch, {getNextWednesday()} um 17:00 Uhr
      </p>
      <p className="text-xl font-semibold">Bis dann!</p>
    </div>
  );
};

export default NextWednesdayDate;